import type { PricingTableCurrencySettings } from '../../types';
import { NumberInputType } from '../../types/enums';
import { PricingTableHelper } from '../pricing-table.helper';

export const getEmptyValue = (value: string): boolean => value === '' || value === '0';

export const getFormattedValue = (
  value: string,
  inputType: NumberInputType,
  currencySettings: PricingTableCurrencySettings
): string => {
  const newValue = value === '' ? '0' : value;
  switch (inputType) {
    case NumberInputType.Number:
      return newValue;

    case NumberInputType.Text:
      return newValue;

    case NumberInputType.Percentage:
      return `${newValue}%`;

    case NumberInputType.Currency:
      return PricingTableHelper.currencyFormat(newValue, currencySettings);

    default:
      return newValue;
  }
};

export const getType = (
  value: string,
  inputType: NumberInputType,
  currencySettings: PricingTableCurrencySettings
): string => {
  switch (inputType) {
    case NumberInputType.Number:
    case NumberInputType.Percentage:
    case NumberInputType.Currency:
      return 'number';

    case NumberInputType.Text:
      return 'text';

    default:
      return getFormattedValue(value, inputType, currencySettings);
  }
};
